<template src="./availabilitySearch.template.html"></template>
<script>
    import moment from "moment-timezone";
    import vueSlider from '../sliderComponent/vue-slider/';
    import { IntegerPlusminus } from 'vue-integer-plusminus';
    import Vue from "vue";
    import observevisibility from './src/directives/observe-visibility'
    // import 'vue-virtual-infinite-scroll/dist/css/vue-virtual-infinite-scroll.css'
    import VueObserveVisibility from 'vue-observe-visibility';
    // Vue.component('virtual-list', virtualScroll)

    Vue.use(VueObserveVisibility)



    export default {
        name: "availabilitySearch",
        props: [],
        components: {
            vueSlider,
            IntegerPlusminus
        },
        data() {
            return {
                PageNo: 1,
                ItemsPerPage: 20,
                showMapView: true,
                pricecount: 0,
                Count: 0,
                filterLabel: "Filter",
                isPannelInfo: true,
                showMask: false,
                mapWidth: {},
                resultsWidth: {},
                apiUrl: window.location.protocol + '//' + window.location.hostname + (window.location.port ? ":1339" : ''),
                Reservationid: -1,
                confirmationid: -1,
                options: {
                    scrollbars: true,
                    interactiveScrollbars: true,
                    probeType: 3,
                    mouseWheel: true,
                    mouseWheelSpeed: 1
                },
                showunits: true,
                isAvailable: false,
                variable: false,
                pullDownTextObj: {
                    trigger: 'Loading...',
                    begin: 'Loading...',
                    complete: 'There are no items',
                    error: 'There is server error',
                    refresh: 'Loading...'
                },
                dateObj: {
                    startDate: moment.utc().format("YYYY-MM-DD"),
                    endDate: moment.utc().format("YYYY-MM-DD"),
                },
                BestAvailableRate: {},
                items: [],
                searchflag: null,
                Totalcount: null,
                loading: false,
                availableRoomsList: [],
                filteredUnits: [],
                isShow: true,
                guestList: [
                ],
                value: 50,
                locationsList: [],
                selectedUnit: [],
                singleCard: false,
                tripleCard: false,
                isLoading: true,
                showSearch: true,
                expand: true,
                collapse: false,
                demo3: {
                    value: [0, 100],
                    width: '15%',
                    height: 8,
                    dotSize: 16,
                    min: 0,
                    max: 2000,
                    disabled: false,
                    show: true,
                    useKeyboard: true,
                    tooltip: 'always',
                    formatter: '${value}',
                    enableCross: false,
                    mergeFormatter: '${value1} ~ ${value2}',
                    bgStyle: {
                        backgroundColor: '#fff',
                        boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
                    },
                    tooltipStyle: {
                        backgroundColor: '#666',
                        borderColor: '#666'
                    },
                    processStyle: {
                        backgroundColor: '#999'
                    }
                },
                ChargesPattern: "",
                AccomodationPattern: "",
                folioItemCharges: [],
                folioCharges: {},
                Best_Available_Rate: {},
                currUnitObj: {},
                latLogList: [],
                Boundries: [],
                // unavailableLatLong: [],
                beData: {},
                disbleSelectButton: true,
                isPotrait: true,
                resultPan: '',
                gMapWidth: {},
                slideOpen: false,
                slideClose: true,
                TotalUnitsCount: null,
                isWebView: null,
                // Hscroll: false,
                selectButtonSummery: false,
                stopVisibilityChanged: false,
                scrollHor: null,
                source: "",
                fromMap: false,
                startScroll: true,
                bit: "",
                prevScrollpos: 0,
                isScrolling: false,
                showRate: false,
                // EntryFile:[]
                isVisible: true,
                scrollflag: 0,
                scrollinipad: null,
                showDatesPanel: false,
                showFilterPanel: false
            }
        },
        methods: {
            showRatesList(item) {
                let vm = this;
                item.ShowRates = !item.ShowRates;
                if(vm.$gtag){
                    vm.$gtag.event('Select Rate Plan', {
                        'event_category': 'Select Rate Plan',
                        'event_label': 'Select Rate Plan',
                    })
                }
            },
            // setlabel(){
            //     let vm = this;
            //     for(var i = 0; vm.availableRoomsList){

            //     }
            // },
            // calculateHeight() {
            //      //this.height = this.$refs.resultWrap.clientHeight;
            //      console.log(this.$refs.resultWrap.clientWidth);
            //     //  let cw = this.$refs.resultWrap.clientWidth;
            //     //  let mpWrap
            // },
            // formatStartDate(date) {
            //     return moment(date, "YYYY-MM-DD").format("MMM DD");
            // },
            openfilterpannel() {
                let vm = this;
                vm.showFilterPanel = !vm.showFilterPanel
                vm.$store.state.bus.$emit("DatesPannel", false);
                vm.showDatesPanel = false;
                vm.$store.state.bus.$emit("moreOptionPannel", vm.showFilterPanel);

            },
            formatStartDate(date) {
                return moment(date).format("MMM DD");
            },
            formatendDate(date) {
                return moment(date).format("MMM DD");
            },
            openDatesPanel() {
                let vm = this;
                console.log("vm.FiltersCount", vm.FiltersCount)
                vm.showDatesPanel = !vm.showDatesPanel
                if (vm.FiltersCount <= 1) {
                    vm.filterLabel = "Filter"
                }
                else {
                    vm.filterLabel = "More Filters"
                }
                vm.$store.state.bus.$emit("moreOptionPannel", false);
                vm.showFilterPanel = false
                vm.$store.state.bus.$emit("DatesPannel", vm.showDatesPanel);


            },

            visibilityChanged(isVisible, entry, from) {
                let vm = this
                vm.isVisible = isVisible;
                // var err = new Error();
                // console.log("err.stack=>", err.stack);
                // console.log("trace=>", console.trace());
                console.log("entry", entry)

                if (vm.isVisible) {
                    // let UnitData = vm.availableRoomsList.filter(y => y.PropertyId == entry.target.id);
                    for (var i in vm.availableRoomsList) {
                        if (vm.availableRoomsList[i].PropertyId == (from == "fromMethod" ? entry : entry.target.id)) {
                            let unitData = vm.availableRoomsList[i];
                            // console.log("unitData==>",unitData);
                            console.log("vm.scrollflag", vm.scrollflag)
                            if (vm.scrollflag <= 0) {

                                // console.log("calling visibility: scrollflag")
                                // console.log("entry================>",unitData);
                                vm.mouseOverOnCard(unitData);
                                // }

                            }
                            else {
                                console.log("Skipping Card Move: scrollflag")
                            }

                        }
                    }
                }
            },

            mouseLeaveOnCard(item) {
                let vm = this;
                var i;
                for (i = 0; i < vm.availableRoomsList.length; i++) {

                    if (vm.availableRoomsList[i].latitude == item.latitude && vm.availableRoomsList[i].longitude == item.longitude) {
                        // console.log("vm.availableRoomsList[i]", vm.availableRoomsList[i]);
                        vm.$set(
                            vm.availableRoomsList[i],
                            "class",
                            "tagItemInAct"
                        );

                    }
                    else {
                        vm.$set(
                            vm.availableRoomsList[i],
                            "class",
                            "tagItemInAct"
                        );
                    }





                }
                vm.$store.state.bus.$emit("removeMarkLatitudeAndLongitude", { latitude: item.latitude, longitude: item.longitude });
            },
            mouseOverOnCard(item) {
                let vm = this;
                // console.log("item item", item);
                var i;
                for (i = 0; i < vm.availableRoomsList.length; i++) {

                    if (vm.availableRoomsList[i].latitude == item.latitude && vm.availableRoomsList[i].longitude == item.longitude) {
                        // console.log("vm.availableRoomsList[i]", vm.availableRoomsList[i]);
                        vm.$set(
                            vm.availableRoomsList[i],
                            "class",
                            "tagItemAct"
                        );
                        // $(".booking-eng-list").animate({ scrollTop: 0 }, 600);

                    }
                    else {
                        vm.$set(
                            vm.availableRoomsList[i],
                            "class",
                            "tagItemInAct"
                        );
                    }





                }
                vm.$store.state.bus.$emit("markLatitudeAndLongitude", { latitude: item.latitude, longitude: item.longitude });
            },
            formatMoney(amount) {
                return this.$store.state.getFormattedAmountBE("$", amount);
            },
            getProperties(values) {
                let vm = this;
                console.log("here in getProperties");
                // console.log("vm.availableRoomsList", vm.availableRoomsList.length);
                // vm.availableRoomsList.sort(function () {
                //     return 
                // })
                vm.filteredUnits = vm.availableRoomsList.filter(
                    unit => unit.latitude == values.latitude && unit.longitude == values.longitude
                );
                vm.availableRoomsList = vm.availableRoomsList.filter(
                    unit => unit.latitude != values.latitude && unit.longitude != values.longitude
                );
                // console.log("vm.filteredUnits", vm.filteredUnits);
                // console.log("vm.availableRoomsList", vm.availableRoomsList.length);

            },

            text_truncate(str, length, ending) {
                // console.log("stringggtext", str.length);
                if (str && str.length) {
                    str = str.replaceAll("<br>", " ");
                    if (length == null) {
                        length = 110;
                    }
                    if (ending == null) {
                        ending = '...';
                    }
                    if (str.length > length) {
                        return str.substring(0, length - ending.length);
                    } else {
                        return str;
                    }
                }

            },
            getUnitInfo(inst) {
                let vm = this;
                console.log("inst", inst);
                //if (inst.URL != null) {
                this.$store.dispatch("guestInformation", {
                    data: {
                        selectedunit: inst,
                    }
                })
                vm.$router.push("/unitDetail" + "/" + inst.UnitId + "/" + inst.PropertyId + "/")

                //window.open(inst.URL, inst.PropertyName + '-' + inst.UnitName);
                //}
                // let routeData = this.$router.resolve({ name: 'UnitDetails', params:{ PropertyId: inst.PropertyId , UnitId: inst.UnitId} });
                // window.open(routeData.href, '_blank');
            },
            getMoreData($stateChange) {
                if (this.items.length >= this.Totalcount) {
                    $stateChange('complete')
                } else {
                    setTimeout(() => {
                        $stateChange('loaded')
                    }, 1500)
                    this.filterObj.PageNo++

                    this.getAvailableRooms();
                }
            },
            refreshData($pullStateChange) {
                setTimeout(() => {
                    this.items.splice(0)
                    $pullStateChange('complete')
                }, 1500)
            },
            bookNow(inst) {
                let vm = this;
                console.log("inst===>", inst);
                this.$store.dispatch("guestInformation", {
                    data: {
                        selectedunit: inst,
                    }
                })

                vm.$router.push("/guestInfoAndPayment/" + -1);
            },
            // formatMoney(amount) {
            //     return this.$store.state.getFormattedAmount("$", amount);
            // },
            formatDate(date) {
                return moment(date, "YYYY-MM-DD").format("DD MMM ");
            },

            formatStartDate(date) {
                let vm = this;
                let startYear = moment(vm.$store.state.filterObj.startDate, "YYYY-MM-DD").format("YYYY");
                let endYear = moment(vm.$store.state.filterObj.endDate, "YYYY-MM-DD").format("YYYY");

                if (startYear == endYear) {
                    return moment(date, "YYYY-MM-DD").format("DD MMM ");
                }
                else {
                    return moment(date, "YYYY-MM-DD").format("DD MMM YYYY");
                }
            },
            updateValues(values) {
                let scope = this;
                console.log("here", values);
                scope.$store.state.filterObj.startDate = moment(values.startDate).format("YYYY-MM-DDTHH:mm:ss");
                scope.$store.state.filterObj.endDate = moment(values.endDate).format("YYYY-MM-DDTHH:mm:ss");

                // startAndEndTexts
                // scope.$store.state.bus.$emit("startAndEndTexts", { startDate: values.startDate.toISOString().slice(0, 10), endDate: values.endDate.toISOString().slice(0, 10) });
            },

            formatEndDate(date) {
                let vm = this;
                let startYear = moment(vm.$store.state.filterObj.startDate, "YYYY-MM-DD").format("YYYY");
                let endYear = moment(vm.$store.state.filterObj.endDate, "YYYY-MM-DD").format("YYYY");
                return moment(date, "YYYY-MM-DD").format("DD MMM YYYY");
            },


            GetFolioLedgerTransDetails_beforesave() {
                let vm = this;
                let persons = "";
                let adults = "";
                let children = "";
                if ((vm.filterObj.Persons == null || vm.filterObj.Persons == "" || vm.filterObj.Persons == -99) && vm.filterObj.Adults == -99 && vm.filterObj.Children == -99) {
                    persons = vm.selectedUnit.MaxPersons;
                    adults = null;
                    children = null;


                }

                else if ((vm.filterObj.Adults == null || vm.filterObj.Adults == "" || vm.filterObj.Adults == -99) && ((vm.filterObj.Children == null || vm.filterObj.Children == "" || vm.filterObj.Children == -99) && vm.filterObj.Persons != -99)) {
                    persons = vm.filterObj.Persons;
                    adults = null;
                    children = null;

                }
                else if ((vm.filterObj.Adults != -99) && (vm.filterObj.Children == -99 || vm.filterObj.Children == null || vm.filterObj.Children == "") && vm.filterObj.Persons == -99) {
                    adults = vm.filterObj.Adults;
                    children = null;
                    persons = null;
                }
                else if ((vm.filterObj.Children != -99) && (vm.filterObj.Adults == -99 || vm.filterObj.Adults == null || vm.filterObj.Adults == "") && vm.filterObj.Persons == -99) {
                    adults = null;
                    persons = null;
                    children = vm.filterObj.Children;
                }
                else if (vm.filterObj.Adults != -99 && vm.filterObj.Children != -99 && vm.filterObj.Persons == -99) {
                    adults = vm.filterObj.Adults;
                    children = vm.filterObj.Children;
                    persons = null;
                }
                else {
                    persons = vm.filterObj.Persons;
                }

                let obj = {
                    FolioId: null,
                    ReservationId: null,
                    UnitId: vm.selectedUnit.UnitId,
                    PropertyId: vm.selectedUnit.PropertyId,
                    StartDate: vm.$store.state.filterObj.startDate,
                    EndDate: vm.$store.state.filterObj.endDate,
                    NumOfAdults: adults,
                    NumOfChildren: children,
                    Persons: persons,
                    systemParams: {
                        SelectedClientId: 7,
                        UserId: 40

                    }
                };
                vm.folioItemCharges = [];
                vm.folioCharges = {};
                console.log("obj", obj);




                let sucessCallback = function (response) {
                    console.log("response in GetFolioLedgerTransDetails", response);
                    if (response && response.data) {
                        if (response.data[0]) {
                            vm.folioItemCharges = response.data[0]
                        }
                        if (response.data[2]) {
                            vm.folioCharges = response.data[2][0];
                        }
                        if (response.data[3]) {
                            vm.BestAvailableRate = response.data[3][0];
                        }

                    }
                },
                    failureCallback = function (error) {
                        console.log(error);
                    };

                vm.$store.state.sendApiRequest("beApi/GetFolioLedgerTransDetails", "post", obj, sucessCallback, failureCallback);
            },

            showReservationSummaryPanel(inst, ratePlan) {
                let vm = this;
                vm.selectButtonSummery = true;
                if (vm.selectButtonSummery == true) {
                    // document.getElementById("custom-nav-bar").style.display = "";
                    // window.localStorage.setItem("component", "panel");
                }
                // if (vm.$store.state.filterObj.showguestdropdown && vm.$store.state.filterObj.Persons == "-99") {

                //     vm.$store.dispatch("toastr", {
                //         type: "warning",
                //         header: "Warning!",
                //         message: "Please search with guests"
                //     });
                //     return;
                // }
                // else if (!vm.$store.state.filterObj.showguestdropdown && vm.$store.state.filterObj.Adults == "-99") {
                //     vm.$store.dispatch("toastr", {
                //         type: "warning",
                //         header: "Warning!",
                //         message: "Please search with Adults"
                //     });
                //     return;
                // }
                if (ratePlan) {
                    inst.RatePlanId = ratePlan.RatePlanId
                    inst.Promocode = ratePlan.PromoCodes ? ratePlan.PromoCodes.join() : null;
                }
                vm.selectedUnit = inst;
                vm.$store.state.selectedUnit = inst;
                vm.$store.state.filterObj.unitId = inst.UnitId;
                vm.$store.state.filterObj.RatePlanId = inst.RatePlanId;
                vm.$store.state.filterObj.Promocode = inst.Promocode;
                if (inst && inst.UnitId) {
                    console.log("inst", inst);
                    vm.currUnitObj = {}
                    setTimeout(function () {
                        vm.currUnitObj = inst;
                    }, 100);

                    if(vm.$gtag){
                        vm.$gtag.event('ShoppingCart Display', {
                            'event_category': 'ShoppingCart',
                            'event_label': 'ShoppingCart',
                        })
                    }
                }


                // vm.$store.state.filterObj.unitId = inst.UnitId;
                // vm.dateObj.startDate=  moment.utc().format("YYYY-MM-DD");
                // vm.dateObj.endDate =  moment.utc().format("YYYY-MM-DD");
                // $(".reservationSummary").addClass("expand");
                // $(".menuMaskRevSum").toggle();
                // $(".reservationSummary").removeClass("menuMaskRevSum");
                // vm.GetFolioLedgerTransDetails_beforesave();
            },
            panelCallback() {
                let vm = this;
                // vm.currUnitObj = {}
                console.log("here");

            },

            closeSummaryPannel() {
                let vm = this;
                $(".menuMaskRevSum").hide();
                $(".reservationSummary").removeClass("expand");
                vm.$store.state.filterObj.unitId = null;
                vm.dateObj.startDate = moment.utc().format("YYYY-MM-DD");
                vm.dateObj.endDate = moment.utc().format("YYYY-MM-DD");
                // vm.$store.state.filterObj.startDate=  null;
                // vm.$store.state.filterObj.endDate =  null;
            },
            checkedValues(value, event) {
                let vm = this;
                console.log("checkedValues", value + " " + event.target.checked);


                if (event.target.checked == true) {
                    console.log("here", value)
                    vm.$store.state.filterObj.FilteredAmenities.push(value);
                }
                else if (event.target.checked == false) {
                    var index = vm.$store.state.filterObj.FilteredAmenities.indexOf(value);
                    if (index > -1) {
                        vm.$store.state.filterObj.FilteredAmenities.splice(index, 1);
                    }
                }
                console.log("vm.filterObj.FilteredAmenities", vm.$store.state.filterObj.FilteredAmenities);
            },
            show(flag) {
                console.log("flag", flag)
                let vm = this;
                if (flag == "hideFilters") {
                    vm.isShow = true;
                }
                else if (flag == "showFilters") {
                    vm.isShow = false;
                }
            },
            imageURLS(imgGuid) {

                let isBase64 = /^data:image\/([a-zA-Z]*);base64,([^\"]*)/.test(imgGuid)
                if (isBase64) {
                    return imgGuid;
                }
                return this.apiUrl + '/downloadImage/' + imgGuid + '/430x300';
            },
            scroll() {
                // $(".booking-eng-list").animate({ scrollTop: 0 }, 600);
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            },
            // updateStopVisibilityChanged() {
            //     let target = document.querySelector('.testScroll')
            //     let options = {
            //         root: document.querySelector('.testScroll'),
            //         rootMargin: '0px',
            //         threshold: 1.0
            //     }

            //     let observer = new IntersectionObserver(this.visibilityChanged, options);
            //     observer.disconnect(target);

            //     // observer.unobserve()
            //     this.stopVisibilityChanged = false


            // },
            // filterPropertiesFromMap(values) {
            //     this.source = "map"

            // },
            getAvailableRooms(values) {
                console.log("values==>", values);
                let vm = this;
                vm.filteredUnits.splice(0);
                vm.showRate = false
                // vm.availableRoomsList = [];
                // if (values) {
                //     vm.scrollflag = values.scrollflag;
                // }


                // vm.stopVisibilityChanged = values ? values.fromMap : false

                vm.showunits = true;
                vm.showMapView = true;
                if (vm.gMapWidth.width == "414px" || vm.gMapWidth.width == "375px" || vm.gMapWidth.width == "320px" || vm.gMapWidth.width == "411px" || vm.gMapWidth.width == "360px") {
                    // vm.availableRoomsList = [];
                    // vm.availableRoomsList.splice(0)
                }

                // vm.availableRoomsList.splice(0)


                vm.$store.state.filterObj.unitId = null;
                vm.$store.state.filterObj.ByUnits = vm.beData.ByUnits
                vm.$store.state.filterObj.PageNo = vm.PageNo;
                vm.$store.state.filterObj.ItemsPerPage = vm.ItemsPerPage;

                let sucessCallback = function (response) {

                    console.log("response in GetAvailability_BE", response);
                    vm.loading = false;
                    if (response && response.data && response.data.resultSet) {

                        if (response.data.resultSet[3]) {
                            // vm.Boundries = [];
                            vm.latLogList = response.data.resultSet[3];

                        }
                        // else if (response.data[3] && response.data[3][0].IsAvailable == false) {
                        //     vm.latLogList = [];
                        //     vm.Boundries = response.data[3];
                        // }
                        if (response.data.resultSet[2] && response.data.resultSet[2].length) {
                            console.log("response.data.resultSet[2][0].TotalCount", response.data.resultSet[2][0].TotalCount)
                            vm.TotalUnitsCount = response.data.resultSet[2][0].TotalCount;
                        }
                        if (response.data.resultSet[5] && response.data.resultSet[5].length) {
                            vm.ChargesPattern = response.data.resultSet[5][0].ChargesPattern;
                            vm.AccomodationPattern = response.data.resultSet[5][0].AccomodationPattern;
                        }
                        if (response.data.resultSet[4]) {
                            vm.unavailableLatLong = response.data.resultSet[4];
                        }
                        if (response.data.resultSet[3]) {
                            if (!values) {
                                vm.addMarker();
                            }

                        }

                        if (response.data.roomDetailsListObjs) {
                            vm.loading = false;
                            // vm.currUnitObj = {}
                            // document.getElementByClass("booking-eng-list").scrollTop = 0;

                            // vm.availableRoomsList = response.data[1];
                            // vm.availableRoomsList.splice(0, vm.availableRoomsList.length, ...response.data.roomDetailsListObjs);
                            // if (response.data.roomDetailsListObjs.length > 0) {
                            let unitList = response.data.roomDetailsListObjs;
                            if (vm.PageNo == 1) {
                                vm.availableRoomsList.splice(0, vm.availableRoomsList.length, ...unitList)
                            } else {
                                vm.availableRoomsList.push.apply(vm.availableRoomsList, unitList);
                            }
                            // }
                            setTimeout(function () {
                                if (!vm.isWebView && !vm.isWebView != null && !(window.innerHeight < window.innerWidth)) {
                                    var container = document.getElementsByClassName('booking-eng-list')[0];
                                    console.log("container", container);
                                    console.log("container", container.style);
                                    // container.style.width = "auto";
                                    // var window_width = window.innerWidth;

                                    $('.card').css('width', screen.width - 50 + 'px');
                                    var block_width = document.getElementsByClassName("card")[0];
                                    // block_width.style.width = screen.width + 'px';
                                    container.style.width = (vm.availableRoomsList.length * (screen.width - 50)) + 'px';
                                    console.log("container.style.width", block_width.style);
                                    // vm.scrollHor = true;
                                    if (!values) {
                                        var $scrollerTO = $('.beListWrap');
                                        var scrollToLeft = $('.card:first').position().left;
                                        $scrollerTO.animate({ 'scrollLeft': scrollToLeft }, 200);
                                    }

                                }
                            }, 300);

                            vm.showunits = false;
                            if (vm.availableRoomsList.length <= 0) {
                                vm.showMapView = false;
                            }
                            console.log("values in availbility", values);

                            if (values) {
                                // vm.scroll();
                                var i;
                                for (i = 0; i < vm.availableRoomsList.length; i++) {

                                    if (vm.availableRoomsList[i].latitude == values.latitude && vm.availableRoomsList[i].longitude == values.longitude) {
                                        console.log("vm.availableRoomsList[i]", vm.availableRoomsList[i]);

                                        vm.scrollflag = vm.scrollflag < 0 ? 1 : vm.scrollflag + 1;
                                        console.log("Setting scrollflag")

                                        vm.$set(
                                            vm.availableRoomsList[i],
                                            "class",
                                            "tagItemAct"
                                        );
                                        vm.$set(
                                            vm.availableRoomsList[i],
                                            "here",
                                            "here"
                                        );
                                        vm.availableRoomsList[i].class = "tagItemAct";

                                        setTimeout(() => {
                                            vm.scrollflag -= 1;

                                            console.log("unsetting scrollflag", vm.scrollflag);
                                        }, 3000);


                                        // $(".booking-eng-list").animate({ scrollTop: 0 }, 600);
                                        // vm.wholeScreenButton.superView.bringSubviewToFront(vm.availableRoomsList[i].label)

                                    }
                                    else {
                                        vm.$set(
                                            vm.availableRoomsList[i],
                                            "class",
                                            "tagItemInAct"
                                        );
                                        vm.$set(
                                            vm.availableRoomsList[i],
                                            "here",
                                            ""
                                        );
                                        vm.availableRoomsList[i].class = "tagItemInAct"
                                        // self.view.bringSubviewToFront(vm.availableRoomsList[i].label);
                                        // vm.wholeScreenButton.superView.bringSubviewToFront(vm.availableRoomsList[i].label)

                                    }
                                }

                                // if (vm.availableRoomsList[i].class = "tagItemAct") {
                                setTimeout(function () {
                                    console.log("prev", $(".here:first").prev().length)
                                    console.log("in horizontal", vm.$refs.mapWraper.clientWidth)
                                    let Scrolling = null
                                    if (!vm.isWebView && !vm.isWebView != null && !(window.innerHeight < window.innerWidth)) {
                                        $(".beListWrap").scroll(function () {
                                            console.log("scrollingggggggggggggg");
                                            vm.isScrolling = true;
                                            clearTimeout($.data(this, "scrollCheck"));
                                            $.data(this, "scrollCheck", setTimeout(function () {
                                                vm.isScrolling = false;
                                                if (Scrolling == null && vm.isScrolling == false) {
                                                    var $scroller = $('.beListWrap');
                                                    // vm.filteredUnits = vm.availableRoomsList.filter(
                                                    //     unit => unit.latitude == values.latitude && unit.longitude == values.longitude
                                                    // );
                                                    // vm.availableRoomsList = vm.availableRoomsList.filter(
                                                    //     unit => unit.latitude != values.latitude && unit.longitude != values.longitude
                                                    // );

                                                    var scrollTo = $('.here:first').position().left;

                                                    console.log("scroll to position", scrollTo)
                                                    $scroller
                                                        .animate({ 'scrollLeft': scrollTo }, 350);
                                                    Scrolling = true
                                                    // vm.scrollHor = true;
                                                }
                                            }, 50));

                                        });
                                        if (Scrolling == null && vm.isScrolling == false) {
                                            var $scroller = $('.beListWrap');
                                            // vm.filteredUnits = vm.availableRoomsList.filter(
                                            //     unit => unit.latitude == values.latitude && unit.longitude == values.longitude
                                            // );
                                            // vm.availableRoomsList = vm.availableRoomsList.filter(
                                            //     unit => unit.latitude != values.latitude && unit.longitude != values.longitude
                                            // );

                                            var scrollTo = $('.here:first').position().left;

                                            console.log("scroll to position", scrollTo)
                                            $scroller
                                                .animate({ 'scrollLeft': scrollTo }, 350);
                                            Scrolling = true
                                            // vm.scrollHor = true;
                                        }






                                    }
                                    else {
                                        vm.filteredUnits = [];
                                        if ($(".here:first").prev().length == 0) {
                                            $('html, body').animate({
                                                scrollTop: 0
                                            }, 600);
                                            $("html, body").scrollTop(0);
                                            // document.body.scrollTop = 0;
                                            // document.documentElement.scrollTop = 0;
                                        }
                                        else if (vm.gMapWidth.width <= "512px") {
                                            var etop = $(".here:first").offset().top - 89;
                                            $('html, body').animate({
                                                scrollTop: etop
                                            }, 350);
                                            // console.log("etopele", etop)
                                        }
                                        else {
                                            var etop = $(".here:first").offset().top - 153;
                                            $('html, body').animate({
                                                scrollTop: etop
                                            }, 600);
                                            // console.log("etopele", etop)
                                        }
                                    }

                                }, 100);
                                // }
                                // vm.getProperties(values);
                                // tagItemAct
                            }
                        }
                        if (vm.availableRoomsList[0]) {
                            vm.visibilityChanged(true, vm.availableRoomsList[0].PropertyId, "fromMethod");
                        }
                        if (vm.$refs.scrollable) {
                            vm.$refs.scrollable.addEventListener('scroll', vm.handleScroll);
                        }
                        if (vm.$refs.mobileScrollable) {
                            vm.$refs.mobileScrollable.addEventListener('scroll', vm.handleMobileScroll);
                        }
                        if (vm.TotalUnitsCount && vm.TotalUnitsCount < 3) {
                            $("#BE_Scroll").addClass("showBE_Scroll");
                        }
                    }
                },
                    failureCallback = function (error) {
                        console.log(error);
                    };

                setTimeout(() => {
                    if (Object.keys(vm.$route.query).length > 0) {
                        if (vm.$route.query.Location) {
                            var LocationName = vm.$route.query.Location.replaceAll("%20", " ");
                            if (LocationName) {
                                //var searchLocation = vm.$store.state.locationsList.filter(function (item) {
                                var searchLocation = vm.locationsList.filter(function (item) {
                                    return item.CityName.toUpperCase() == LocationName.toUpperCase()
                                })[0];
                                if (searchLocation != undefined) {
                                    vm.filterObj.Location = searchLocation;
                                } else {
                                    vm.filterObj.Location = -99;
                                }
                            }
                        } else {
                            vm.filterObj.Location = -99;
                        }
                        // if (vm.$route.query.Guests) {
                        var Guests = vm.$route.query.Guests;
                        if (Guests) {
                            vm.filterObj.Persons = Guests;
                        } else {
                            vm.filterObj.Persons = -99;
                        }
                        // } 
                        //if (vm.$route.query.Adults) {
                        var Adults = vm.$route.query.Adults;
                        if (Adults) {
                            vm.filterObj.Adults = Adults;
                        } else {
                            vm.filterObj.Adults = -99;
                        }
                        //} 
                        //if (vm.$route.query.Children) {
                        var Children = vm.$route.query.Children;
                        if (Children) {
                            vm.filterObj.Children = Children;
                        } else {
                            vm.filterObj.Children = -99;
                        }
                        //} 

                        var CheckIn = vm.$route.query.CheckIn;
                        var CheckOut = vm.$route.query.CheckOut;
                        if (CheckIn != undefined && CheckOut != undefined) {
                            var validRequest = true;
                            if (CheckIn >= moment.utc(new Date()).format("YYYY-MM-DD") && CheckIn <= CheckOut) {
                                vm.filterObj.startDate = CheckIn;
                            } else {
                                vm.filterObj.startDate = CheckIn
                                validRequest = false;
                            }

                            if (CheckOut >= moment.utc(new Date()).format("YYYY-MM-DD") && CheckOut >= CheckIn) {
                                vm.filterObj.endDate = CheckOut;
                            } else {
                                vm.filterObj.endDate = CheckOut;
                                validRequest = false;
                            }

                            if (!validRequest) {
                                return;
                            }
                        }
                    }
                    console.log("Check Query Params ==> ", vm.$store.state.filterObj)
                    vm.$store.state.filterObj.Location = vm.filterObj.Location;
                    //vm.$store.state.filterObj.Persons = vm.filterObj.Persons;
                    //vm.$store.state.filterObj.Adults = vm.filterObj.Adults;
                    //vm.$store.state.filterObj.Children = vm.filterObj.Children;
                    //vm.$store.state.filterObj.startDate = vm.filterObj.startDate;
                    //vm.$store.state.filterObj.endDate = vm.filterObj.endDate;
                    vm.$store.state.filterObj.PageNo = vm.PageNo;
                    vm.$store.state.filterObj.ItemsPerPage = vm.ItemsPerPage;
                    vm.$store.state.sendApiRequest("beApi/GetAvailability_BE", "post", vm.$store.state.filterObj, sucessCallback, failureCallback);
                }, 1000);
                // event ? event.stopPropagation() : '';
            },
            handleScroll() {
                let vm = this;
                const scrollable = this.$refs.scrollable;
                const lastItem = this.$refs.infinitescrollref;
                const scrollableBottom = scrollable.scrollTop + scrollable.clientHeight;
                const lastItemPosition = lastItem.offsetTop - scrollable.offsetTop - 1;
                console.log("vm.TotalUnitsCount = ", vm.TotalUnitsCount)
                console.log("vm.availableRoomsList.length", vm.availableRoomsList.length)
                console.log("lastItemPosition = ", lastItemPosition)
                console.log("scrollableBottom = ", scrollableBottom)
                // Check if last item is in view
                if (lastItemPosition < scrollableBottom && !vm.loading) {
                    vm.loading = (vm.availableRoomsList.length >= 20 && vm.availableRoomsList.length < vm.TotalUnitsCount && vm.TotalUnitsCount > 20) ? true : false;
                    if (vm.loading) {
                        vm.PageNo += 1;
                        vm.getAvailableRooms();
                    } else {
                        $("#BE_Scroll").addClass("showBE_Scroll");
                    }
                }
            },
            handleMobileScroll() {
                let vm = this;
                const scrollable = this.$refs.mobileScrollable;
                const lastItem = this.$refs.infiniteMobileScrollref;
                const scrollableRight = scrollable.scrollLeft + scrollable.clientWidth;
                const lastItemPosition = lastItem.offsetWidth - scrollable.offsetWidth - 1;
                console.log("vm.TotalUnitsCount = ", vm.TotalUnitsCount)
                console.log("vm.availableRoomsList.length", vm.availableRoomsList.length)
                console.log("lastItemPosition = ", lastItemPosition)
                console.log("scrollableBottom = ", scrollableRight)
                // Check if last item is in view
                if (lastItemPosition < scrollableRight && !vm.loading) {
                    vm.loading = (vm.availableRoomsList.length >= 20 && vm.availableRoomsList.length < vm.TotalUnitsCount && vm.TotalUnitsCount > 20) ? true : false;
                    if (vm.loading) {
                        vm.PageNo += 1;
                        vm.getAvailableRooms();
                    }
                }
            },
            Get_BookingEngine_Config() {
                let vm = this;
                let sucessCallback = function (response) {
                    console.log("response in GetAvailability_BE", response);
                    if (response && response.data) {
                        console.log("response in Get_BookingEngine_Config", response);
                        if (response.data[1] && response.data[1].length) {
                            vm.beData = response.data[1][0];
                            vm.$store.state.filterObj.ByUnits = vm.beData.ByUnits
                        }
                        if (response.data[3] && response.data[3].length) {
                            // vm.latLogList = response.data[3];
                            // vm.addMarker();
                        }
                        if (response.data[7] && response.data[7].length) {
                            vm.locationsList = response.data[7];
                        }
                    }
                },
                    failureCallback = function (error) {
                        console.log(error);
                    };

                vm.$store.state.sendApiRequest("beApi/Get_BookingEngine_Config", "post", {}, sucessCallback, failureCallback);
                // vm.$store.dispatch("dataRequestHandler", {
                //     key: "Get_BookingEngine_Config",
                //     params: {
                //         ModuleAction: "Get_BookingEngine_Config",
                //     },
                //     callback: function (err, response) {
                //         if (err) {
                //             console.log("Error in Get_BookingEngine_Config => ", err);
                //             return;
                //         }
                //         if (response) {
                //             console.log("response in Get_BookingEngine_Config", response);
                //             if (response[3] && response[3].length) {
                //                 vm.latLogList = response[3];
                //                 vm.addMarker();
                //             }
                //         }
                //     }
                // });

            },
            addMarker() {
                let vm = this;

                vm.$store.state.bus.$emit('add-marker', {
                    latitudeLongitude: vm.latLogList,
                    // zoom: 60
                    unavailableLatLong: vm.unavailableLatLong,
                    MinZoomValue: vm.beData.MinZoomValue,
                    MaxZoomValue: vm.beData.MaxZoomValue

                });
            },
            // addMarkerBoundries() {
            //     let vm = this;

            //     vm.$store.state.bus.$emit('add-markerBoundries', {
            //         latitudeLongitude: vm.Boundries,
            //         // zoom: 60
            //         // unavailableLatLong: vm.unavailableLatLong,
            //         MinZoomValue: vm.beData.MinZoomValue,
            //         MaxZoomValue: vm.beData.MaxZoomValue

            //     });
            // },
            // getMapWidth() {
            //     let vm = this;
            //     // setTimeout(() => {
            //     console.log("this.$refs.resultWrap here", this.$refs.resultWrap);
            //     console.log("This is window Width -------------------", window.innerWidth);
            //     let cw = this.$refs.resultWrap.clientWidth;


            //     console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@", cw);
            //     let ccw = (cw / 100) * 40;
            //     if (document.body.offsetWidth <= 1024) {
            //         ccw = (cw / 100) * 30;
            //         this.isPotrait = false;
            //     }
            //     if (document.body.offsetWidth <= 768) {
            //         ccw = (cw / 100) * 50;
            //         this.isPotrait = true;
            //         this.expand = true;
            //     }
            //     if (window.innerHeight > window.innerWidth) {
            //         this.singleCard = true;
            //         ccw = (cw / 100) * 50;
            //     }
            //     console.log("Caliculated With is here: - ", ccw);
            //     let calcLeft = (window.innerWidth - cw) / 2;
            //     let obj = {
            //         'max-width': ccw + 'px',
            //         'width': ccw + 'px',
            //         'flex-basis': ccw + 'px',
            //         'left': calcLeft + 'px'
            //     }
            //     console.log("obj", obj)

            //     vm.mapWidth = obj
            //     // }, 2500)

            // },
            initGMapWidth() {
                this.$nextTick(this.getGMapWidth);
                window.addEventListener("resize", this.getGMapWidth);
                this.isLoading = false;
            },
            getGMapWidth() {
                if (!this.$refs.mapWraper) {
                    return;
                }

                let vm = this;
                let cw = this.$refs.mapWraper.clientWidth;
                vm.$store.state.bus.$emit("mapWidth", cw);
                console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^", cw);
                console.log("screen.width", screen.width)
                if (cw == 0) {
                    if (screen.width == "768") {
                        cw = 384
                    }
                    else if (screen.width == "1024") {
                        cw = 512
                    }
                }
                let obj = {
                    'width': cw + 'px'
                }
                vm.gMapWidth = obj
                // alert(window.innerHeight)
                if (window.innerHeight == 922) {
                    $('#map').css('height', '815' + 'px');
                }

                else if (window.innerHeight == 985) {
                    $('#map').css('height', '875' + 'px');
                }
                else if (window.innerHeight == 729) {
                    // alert("890")
                    $('#map').css('height', '625' + 'px');
                }
                else if (window.innerHeight == 666) {
                    $('#map').css('height', '560' + 'px');
                }
                else if (window.innerHeight == 1264) {
                    // alert("890")
                    $('#map').css('height', ' 1160' + 'px');
                }
                else if (window.innerHeight == 1327) {
                    $('#map').css('height', '1220' + 'px');
                }



                setTimeout(() => {

                    if (cw <= "450" && cw != "384" && cw != "77" && cw != "307" && cw != "102") {
                        console.log("mmmmmmmmmmmmmmmmmmmmmmmmmm", screen.width)
                        vm.isWebView = false;
                        vm.scrollinipad = false;


                        if (!(window.innerHeight < window.innerWidth) && vm.availableRoomsList.length > 0) {
                            console.log("hori1")

                            setTimeout(() => {
                                var container = document.getElementsByClassName('booking-eng-list')[0];
                                var window_width = window.innerWidth;
                                var block_width = document.getElementsByClassName("card")[0];
                                $('.card').css('width', screen.width - 50 + 'px');
                                // block_width.style.width = screen.width + 'px';
                                container.style.width = (vm.availableRoomsList.length * (screen.width - 50)) + 'px';

                            }, 100)

                        }
                        else if (!(window.innerHeight < window.innerWidth)) {
                            console.log("hori2")
                            $('.card').css('width', screen.width + 'px');
                        }
                        else if (window.innerHeight < window.innerWidth) {
                            console.log("ver")
                            // var container = document.getElementsByClassName('booking-eng-list')[0];
                            $('.booking-eng-list').css('width', 'auto');

                            // var window_width = window.innerWidth;
                            // var block_width = document.getElementsByClassName("card")[0];
                            // $('.card').css('width', '' + 'px');
                            // block_width.style.width = screen.width + 'px';
                            // container.style.width = "auto"
                            // $('.card').css('width', 100 + 'px');
                        }
                        // var container = document.getElementById('container');
                        // container.style.width = "auto";
                        // var window_width = window.innerWidth;
                        // var block_width = document.getElementsByClassName("block")[0].offsetWidth;
                        // var maxBoxPerRow = Math.floor(window_width / block_width);
                        // container.style.width = (maxBoxPerRow * block_width) + 'px';




                    }
                    else if (window.innerWidth == 1024 || window.innerWidth == 1366 || window.innerWidth == 768) {
                        vm.scrollinipad = true;
                        vm.isWebView = true;
                    }

                    else {
                        console.log("wwwwwwwwwwwwwwwwwwwwwwwwwwwww")
                        vm.isWebView = true;
                        vm.scrollinipad = false;

                    }

                }, 50)


            },



            windowScroll() {
                let vm = this;
                setTimeout(() => {
                    // if (window.innerWidth <= 414) {
                    //     var prevScrollpos = window.pageYOffset;
                    //     window.onscroll = function () {
                    //         var currentScrollPos = window.pageYOffset;
                    //         if (prevScrollpos < currentScrollPos) {
                    //             document.getElementById("custom-nav-bar").style.top = "0px";
                    //             document.getElementById("customsearch").style.top = "120px";
                    //             document.getElementById("page-content").style.padding = "";
                    //             if (vm.showMask == true) {
                    //                 document.getElementById("customsearch").style.top = "370px";
                    //             }
                    //             else {
                    //                 document.getElementById("customsearch").style.top = "120px";
                    //             }
                    //         }
                    //         else if (vm.showMask == false) {
                    //             document.getElementById("customsearch").style.top = "-50px";
                    //             // document.getElementById("customsearch").style.top = "295px";
                    //             document.getElementById("custom-nav-bar").style.top = "-120px";
                    //             document.getElementById("page-content").style.padding = "0px";
                    //         }
                    //         else {
                    //             document.getElementById("custom-nav-bar").style.top = "-120px";
                    //             document.getElementById("customsearch").style.top = "282px";
                    //             document.getElementById("page-content").style.padding = "0px";
                    //         }
                    //         prevScrollpos = currentScrollPos;
                    //     }
                    // }
                    // if (window.innerWidth <= 414) {
                    vm.prevScrollpos = window.pageYOffset;
                    console.log("prevScrollpos", vm.prevScrollpos);


                    // window.addEventListener('scroll', vm.callWindowScrollEvent);
                }, 100)
            },

            callWindowScrollEvent() {
                console.log("scrolling")
                let vm = this;
                if (window.localStorage.getItem("component") !== "search") {
                    return;
                }

                var currentScrollPos = window.pageYOffset;

                if (window.innerWidth <= 414 && window.innerWidth < window.innerHeight) {
                    vm.$store.state.bus.$emit("scrollPOS", { currentScrollPos: currentScrollPos, prevScrollpos: this.prevScrollpos });
                    if (this.prevScrollpos < currentScrollPos) {
                        if (vm.showMask == true) {

                            document.getElementById("custom-nav-bar").style.display = "";
                            document.getElementById("customsearch").style.top = "370px";
                            document.getElementById("customsearch").style.position = "fixed";


                            document.getElementById("page-content").style.padding = "";
                        }
                        else {

                            document.getElementById("custom-nav-bar").style.display = "";
                            document.getElementById("customsearch").style.top = "100px";

                            document.getElementById("page-content").style.padding = "";
                        }
                    }
                    else {
                        if (vm.showMask == true) {

                            document.getElementById("custom-nav-bar").style.display = "none";
                            document.getElementById("customsearch").style.top = "295px";
                            document.getElementById("page-content").style.padding = "0px";
                        }
                        else {

                            document.getElementById("custom-nav-bar").style.display = "none";
                            document.getElementById("customsearch").style.top = "20px";
                            document.getElementById("ListCount").style.top = "20px";
                            document.getElementById("page-content").style.padding = "0px";
                        }
                    }

                    if (window.innerHeight <= 555) {
                        // alert(window.innerHeight)
                        document.getElementById("custom-nav-bar").style.display = "none";
                        document.getElementById("customsearch").style.top = "33px";
                        document.getElementById("ListCount").style.top = "33px";
                        document.getElementById("page-content").style.padding = "0px";
                    }

                    if (window.innerHeight <= 555 && vm.showMask == true) {
                        document.getElementById("customsearch").style.top = "295px";
                    }
                    if (vm.selectButtonSummery == true) {
                        document.getElementById("custom-nav-bar").style.display = "";
                    }


                    this.prevScrollpos = currentScrollPos;
                }
            },
            // getResultsWidth() {
            //     let vm = this;
            //     this.singleCard = false;
            //     // setTimeout(() => {
            //     console.log("this.$refs.resultWrap here", this.$refs.resultWrap);
            //     let cw = this.$refs.resultWrap.clientWidth;
            //     let ccw = ((cw / 100) * 60) - 1;
            //     if (document.body.offsetWidth <= 1245) {
            //         this.singleCard = true;
            //     }
            //     if (document.body.offsetWidth <= 1024) {
            //         ccw = (cw / 100) * 70;
            //     }
            //     if (cw <= 768) {
            //         this.singleCard = true;
            //     }
            //     // if(document.body.offsetWidth <= 768){
            //     //     this.singleCard = true;
            //     //     ccw = (cw / 100) * 50;
            //     // }
            //     if (window.innerHeight > window.innerWidth) {
            //         this.singleCard = true;
            //         ccw = (cw / 100) * 50;
            //         this.expand = true;
            //     } else {
            //         this.singleCard = false;                  
            //     }
            //     if (window.clientWidth <= 768) {
            //         this.singleCard = true;
            //         ccw = (cw / 100) * 50;
            //     }
            //     console.log("Caliculated With is here: - ", ccw)
            //     let obj = {
            //         'max-width': ccw + 'px',
            //         'flex-basis': ccw + 'px'
            //     }
            //     console.log("obj", obj);
            //     vm.resultPan = ccw + "px";
            //     vm.resultsWidth = obj;
            //     // }, 2500)

            // },
            // scrollList() {
            //     window.scrollTo(0, 0);
            // },

            expandMap() {
                // this.collapse = !this.collapse;
                // this.expand = !this.expand;
                // this.singleCard = false;
                // this.tripleCard = true;
                // let vm = this;
                // let cw = this.$refs.resultWrap.clientWidth;
                // let rccw = (cw / 100) * 85;

                // let obj = {
                //     'max-width': rccw + 'px',
                //     'flex-basis': rccw + 'px'
                // }
                // let mccw = (cw / 100) * 15;
                // let objm = {
                //     'max-width': mccw + 'px',
                //     'flex-basis': mccw + 'px'
                // }
                // if(this.isPotrait){
                //     this.tripleCard=false;

                // }
                // vm.resultPan = rccw + "px"
                // vm.resultsWidth = obj
                // vm.mapWidth = objm
                let vm = this;
                this.slideOpen = true;
                this.slideClose = false;
                this.expand = false;
                this.collapse = true;

                setTimeout(() => {
                    let cw = this.$refs.mapWraper.clientWidth;
                    console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^", cw);
                    let obj = {
                        'width': cw + 'px'
                    }
                    vm.gMapWidth = obj
                }, 100)
            },
            collapseMap() {
                let vm = this;
                this.slideOpen = false;
                this.slideClose = true;
                this.expand = true;
                this.collapse = false;

                setTimeout(() => {
                    let cw = this.$refs.mapWraper.clientWidth;
                    console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^", cw);
                    let obj = {
                        'width': cw + 'px'
                    }
                    vm.gMapWidth = obj
                }, 100)
                // this.collapse = !this.collapse;
                // this.expand = !this.expand;
                // this.singleCard = false;
                // this.tripleCard = false;
                // let vm = this;
                // let cw = this.$refs.resultWrap.clientWidth;
                //  let rccw;
                //   let mccw;
                // if(this.isPotrait){
                //      rccw = (cw / 100) * 50;
                // }
                // else{
                //      rccw = (cw / 100) * 70;
                // }


                // let obj = {
                //     'max-width': rccw + 'px',
                //     'flex-basis': rccw + 'px'
                // }
                // if(this.isPotrait){
                //  mccw = (cw / 100) * 50;
                //  this.tripleCard=false;
                //  this.singleCard = true;
                // }
                // else{
                //  mccw = (cw / 100) * 30;
                // }
                // let objm = {
                //     'max-width': mccw + 'px',
                //     'flex-basis': mccw + 'px'
                // }
                // vm.resultsWidth = obj
                //  vm.resultPan = rccw + "px"
                // vm.mapWidth = objm

            },
            ipadRotate() {
                this.collapse = false;
                this.expand = true;
                this.tripleCard = false;
            },
            routeChangeEvent() {
                let vm = this;
                if(vm.$gtag){
                    vm.$gtag.pageview({
                        page_title: 'Availability Search-Page',
                        page_location: window.location.href,
                        page_path: vm.$route.path,
                    })
                }
            }
            // getWrapWidth(){
            //     // console.log("------------------", this.$refs.resultsWidth);
            //     // let wrapWidth = this.$refs.resultsWidth.clientWidth;
            //     // console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$", wrapWidth)

            //     // if (wrapWidth < 768) {
            //     //     this.singleCard = true;
            //     // }
            // }
        },
        computed: {

            filterObj() {
                let vm = this;
                console.log("this.$store.getters.getAvailableUnitsList", this.$store.getters.getFilteredData)
                // vm.$store.state.bus.$emit('clear-markers');
                // vm.addMarker();
                return this.$store.getters.getFilteredData;
            },
            FiltersCount() {
                let vm = this;
                let count = 0
                if (vm.filterObj.Bedrooms > 0 && vm.filterObj.Bathrooms > 0 && vm.filterObj.Beds > 0) {
                    count = 3;
                }
                else if (vm.filterObj.Bedrooms > 0 && vm.filterObj.Bathrooms > 0) {
                    count = 2;
                }
                else if (vm.filterObj.Bathrooms > 0 && vm.filterObj.Beds > 0) {
                    count = 2;
                }
                else if (vm.filterObj.Bedrooms > 0 && vm.filterObj.Beds > 0) {
                    count = 2;
                }
                else if (vm.filterObj.Bedrooms > 0 || vm.filterObj.Beds > 0 || vm.filterObj.Bathrooms > 0) {
                    count = 1;
                }
                // else 
                if (vm.filterObj.value[0] != vm.filterObj.min || vm.filterObj.value[1] != vm.filterObj.max) {
                    vm.pricecount = 1;
                } else {
                    vm.pricecount = 0;
                }
                console.log("count + filterObj.FilteredAmenities.length=>", count + vm.filterObj.FilteredAmenities.length + vm.pricecount)
                return count + vm.filterObj.FilteredAmenities.length + vm.pricecount;

            },
            isVaildSubDomain() {
                let vm = this;
                return vm.$store.state.isValidDomainOrNot;
            },
            beCssObj() {
                if (this.$store.state.cssObj)
                    return this.$store.state.cssObj;
                return null
            },

            selectButton() {
                if (this.$store.state.filterObj)
                    return this.$store.state.filterObj;
                return null
            },

            mapWraperLoaded() {
                return this.isVaildSubDomain;
            }
            // footercssObj() {
            //     if (this.$store.state.FooterStyle)
            //         return this.$store.state.FooterStyle;
            //     return null
            // },
            // getWidthOfWrap: function () {

            //     console.log("this.$refs.resultWrap", this.$refs.resultWrap);
            //     let cw = this.$refs.resultWrap.clientWidth;
            //     let ccw = (cw / 100) * 30;
            //     console.log("Caliculated With is : - ", ccw)
            // }
        },
        mounted() {


            let vm = this;
            // document.getElementById("page-content").style.padding = "";
            // vm.validate();
            window.addEventListener('popstate', () => {
                location.reload();
            });
            setTimeout(() => {
                if(vm.$gtag){
                    vm.$gtag.pageview({
                        page_title: 'Availability Search-Page',
                        page_location: window.location.href,
                        page_path: vm.$route.path,
                    })
                }
            }, 100);
            setTimeout(() => {
                // Detect when scrolled to bottom.
                vm.PageNo = 1
                if (this.$refs.mobileScrollable) {
                    this.$refs.mobileScrollable.addEventListener('scroll', vm.handleMobileScroll);
                }
                if (this.$refs.scrollable) {
                    this.$refs.scrollable.addEventListener('scroll', vm.handleScroll);
                }
                if (vm.TotalUnitsCount && vm.TotalUnitsCount < 3) {
                    $("#BE_Scroll").addClass("showBE_Scroll");
                }
                // const listElm = document.querySelector('#infinite-list');
                // if (listElm) {
                //     listElm.addEventListener('scroll', e => {
                //         const lastItemPosition = this.$refs.infinitescrollref.getBoundingClientRect().top + window.pageYOffset;
                //         console.log("lastItemPosition==" ,lastItemPosition)
                //         if ((listElm.innerHeight + listElm.pageYOffset) >= lastItemPosition && this.lastItemId !== null) {
                //             vm.loading = (vm.availableRoomsList.length < vm.TotalUnitsCount) ? true : false;
                //             if (vm.loading) {
                //                 vm.PageNo += 1;
                //                 vm.getAvailableRooms();
                //             }
                //         }
                //         // if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight - 1) {
                //         //     vm.loading = (vm.availableRoomsList.length < vm.TotalUnitsCount) ? true : false;
                //         //     if (vm.loading) {
                //         //         vm.PageNo += 1;
                //         //         vm.getAvailableRooms();
                //         //     }
                //         // }
                //     });
                // }
            }, 2000)
            vm.Get_BookingEngine_Config();

            // window.removeEventListener('scroll', this.callWindowScrollEvent);
            // $(window).unbind('scroll');
            // 
            // vm.$store.state.bus.$on("getcssObj", function (obj) {
            //     console.log("getcssobjlisten", obj);


            //     var para = document.createElement("style");
            //     para.innerText = obj;
            //     console.log("para.innerText", para.innerText);
            //     var body = document.getElementById("BETemplateBody");
            //     body.appendChild(para);

            // });
            if (this.$store.state.cssObj) {
                var para = document.createElement("style");
                para.innerText = this.$store.state.cssObj;
                //console.log("para.innerText", para.innerText);
                var body = document.getElementById("BETemplateBody");
                body.appendChild(para);
            };

            // window.addEventListener('resize', this.getMapWidth);
            // window.addEventListener('resize', this.getResultsWidth);
            // window.addEventListener('resize', this.ipadRotate);

            // window.addEventListener('orientation', this.getMapWidth);
            // window.addEventListener('orientation', this.getResultsWidth);
            // window.addEventListener('orientation', this.ipadRotate);
            // setTimeout(() => {
            //     // this.getMapWidth();
            //     // this.getResultsWidth();
            //     this.getGMapWidth();
            //     window.addEventListener('resize', this.getGMapWidth);
            //     // window.addEventListener('resize', this.getMapWidth);
            //     // window.addEventListener('resize', this.getResultsWidth);
            //     // window.addEventListener('resize', this.ipadRotate);

            //     // window.addEventListener('orientation', this.getMapWidth);
            //     // window.addEventListener('orientation', this.getResultsWidth);
            //     // window.addEventListener('orientation', this.ipadRotate);
            //     this.isLoading = false;
            // }, 2000)
            if (this.mapWraperLoaded) {
                this.initGMapWidth();
            }

            vm.$store.state.bus.$on("hidesearchResults", function (bit) {
                vm.isPannelInfo = bit;
                console.log("vm.isPannelInfo", vm.isPannelInfo);
            });

            // vm.$store.state.bus.$on("showheaderPannel", function (bit) {
            //     vm.isPannelInfo = bit;
            //     console.log("vm.isPannelInfo",vm.isPannelInfo);
            // });
            vm.$store.state.bus.$on("changeFilterLabel", function () {
                if (vm.FiltersCount > 0) {
                    vm.filterLabel = "More filters"
                } else {
                    vm.filterLabel = "Filter"
                }

            });


            $(".beListWrap").scroll(function () {
                console.log("scrollingggggggggggggg")
                clearTimeout($.data(this, "scrollCheck"));
                $.data(this, "scrollCheck", setTimeout(function () {
                    console.log("stopedddddddddddddddddddddddddddd")
                }, 250));

            });
            // if (this.$store.state.FooterStyle) {
            //     var para = document.createElement("style");
            //     para.innerText = this.$store.state.FooterStyle;
            //     console.log("para.innerText=====>", para.innerText);
            //     //console.log("para.innerText", para.innerText);
            //     var body = document.getElementById("BETemplateBody");
            //     body.appendChild(para);
            // }

            // window.localStorage.setItem("component", "search");
        },
        // beforeRouteEnter(to, from, next) {
        //     if (from.name == 'guestInfo' || from.name == 'unitDetailPage') {
        //         window.location.reload();
        //     }
        //     next();
        // },
        beforeRouteUpdate(to, from, next) {
            if (from.name == 'guestInfo' || from.name == 'unitDetailPage') {
                window.removeEventListener('popstate', () => {
                    location.reload();
                });
            }
            next();
        },
        watch: {
            mapWraperLoaded(newValue, oldValue) {
                console.log("newValue", newValue)
                if (newValue !== oldValue && newValue === true) {
                    this.initGMapWidth();
                }
            },
            isVaildSubDomain(isAvail) {
                if (isAvail) {
                    this.PageNo = 1
                    this.getAvailableRooms();
                }
            },
            beCssObj() {
                //console.log(this.beCssObj);
                if (this.beCssObj) {
                    var para = document.createElement("style");
                    para.innerText = this.beCssObj;
                    console.log("para.innerText", para.innerText);
                    var body = document.getElementById("BETemplateBody");
                    body.appendChild(para);
                }
            },

            selectButton() {
                let vm = this;
                // console.log(this.beCssObj);

                if (vm.selectButton) {
                    if (vm.selectButton.startDate != null && vm.selectButton.endDate != null && (vm.selectButton.Persons != -99 || vm.selectButton.Adults != -99 || vm.selectButton.Children != -99)) {
                        console.log("vm.selectButton", vm.selectButton)
                        vm.disbleSelectButton = false;
                    }
                    else {
                        vm.disbleSelectButton = true;
                    }


                }

            },
            $route: "routeChangeEvent"

            // footercssObj() {
            //     //console.log(this.beCssObj);
            //     if (this.footercssObj) {
            //         var para = document.createElement("style");
            //         para.innerText = this.footercssObj;
            //         //console.log("para.innerText", para.innerText);
            //         var body = document.getElementById("BETemplateBody");
            //         body.appendChild(para);
            //     }
            // }
        },
        created() {
            let vm = this;
            vm.$store.state.bus.$on("callForAvailableunits", function (selected) {
                console.log("selected", selected);
                vm.searchflag = selected;
                vm.filterObj.PageNo = 1
                vm.PageNo = 1
                vm.availableRoomsList.splice(0);
                vm.TotalUnitsCount = 0;
                if (vm.filterObj.PageNo == 1 && vm.searchflag == "call") {
                    vm.items = [];
                    //vm.loading = true;
                }
                $("html, body").animate({ scrollTop: 0 });
                $("#infinite-list").animate({ scrollTop: 0 });
                // $("html, body").animate({ 'scrollLeft': 0 }, "fast");
                vm.getAvailableRooms();
            });

            vm.$store.state.bus.$on("hideMaskpanel", function (bit) {
                vm.showDatesPanel = bit;
                vm.showFilterPanel = bit;
                // vm.show = false
            });
            // vm.$store.state.bus.$on("MaskingUnits", function (flag) {
            //     vm.showMask = flag

            // });

            // window.mySwipe = Swipe(document.getElementById('slider'));
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.getGMapWidth);
            // window.removeEventListener('scroll', this.callWindowScrollEvent);
            // $(window).unbind('scroll');
            // this.prevScrollpos = 0;
            // document.getElementById("page-content").style.padding = "";
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/availabilitySearch/availabilitySearch.vue